module.exports = __webpack_public_path__ + "static/media/arrow-circle-up.085b7797.svg";